<ng-container *ngIf="displayDetails$ | async">
  <span class="title pt-3">Investment Performance</span>
  <!-- Cumulative Performance bullets -->
  <ul class="investment-performance-bullets" [ngClass]="isGpPreview ? 'cols-2' :{
    'cols-2': numberOfBullets() === 1 || numberOfBullets() === 2,
    'cols-3': numberOfBullets() === 3,
    'cols-4': numberOfBullets() === 4 || numberOfBullets() >= 5 }">

    <!-- Cash on cash rate % -->
    <terra-bullet-big-value *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && cumulativeProjectedPerformance.cashOnCashRate != undefined"
                            [value]="cumulativeProjectedPerformance.cashOnCashRate" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.cashOnCashRateMax" unit="%">
      CASH ON CASH RATE
    </terra-bullet-big-value>

    <!-- Non-leveraged cap rate %-->
    <terra-bullet-big-value *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && cumulativeProjectedPerformance.nonLeveragedCapRate != undefined"
                            [value]="cumulativeProjectedPerformance.nonLeveragedCapRate" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.nonLeveragedCapRateMax" unit="%">
      NON-LEVERAGED CAP RATE
    </terra-bullet-big-value>

    <!-- Target investment IRR % -->
    <terra-bullet-big-value *ngIf="cumulativeProjectedPerformance.targetInvestmentIrr != undefined"
                            [value]="cumulativeProjectedPerformance.targetInvestmentIrr" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.targetInvestmentIrrMax" unit="%">
      TARGET INVESTMENT IRR
    </terra-bullet-big-value>

    <!-- Expected ROI % -->
    <terra-bullet-big-value *ngIf="holdingDiscriminator === HoldingDiscriminator.Asset && cumulativeProjectedPerformance.expectedRoi != undefined"
                            [value]="cumulativeProjectedPerformance.expectedRoi" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.expectedRoiMax" unit="%">
      EXPECTED ROI
    </terra-bullet-big-value>

    <!-- Target equity multiplier (X) -->
    <terra-bullet-big-value *ngIf="cumulativeProjectedPerformance.targetEquityMultiplier != undefined"
                            [value]="cumulativeProjectedPerformance.targetEquityMultiplier" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.targetEquityMultiplierMax" fractionSize="2"
                            unit="x">
      TARGET EQUITY MULTIPLE
    </terra-bullet-big-value>

    <!-- Preferred return % -->
    <terra-bullet-big-value *ngIf="cumulativeProjectedPerformance.preferredReturn != undefined"
                            [value]="cumulativeProjectedPerformance.preferredReturn" [isGpPreview]="isGpPreview"
                            [toValue]="cumulativeProjectedPerformance.preferredReturnMax" unit="%">
      PREFERRED RETURN
    </terra-bullet-big-value>

    <terra-bullet-big-value *ngIf="cumulativeProjectedPerformance.targetInvestmentPeriod != undefined" [isGpPreview]="isGpPreview"
                            [value]="cumulativeProjectedPerformance.targetInvestmentPeriod" [unit]="cumulativeProjectedPerformance.targetInvestmentPeriod >= 2 ? ' YEARS' : ' YEAR'">
      TARGET INVESTMENT PERIOD
    </terra-bullet-big-value>
  </ul>
</ng-container>
